// src/pages/Nous.jsx
import React from "react";
import { Box } from "@mui/material"; 
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroSection from "../components/informations/HeroSection";
import ValeurSection from "../components/informations/ValeurSection";
import EquipeSection from "../components/informations/EquipeSection";
import AccompagnementSection from "../components/informations/AccompagnementSection";

const Nous = () => {
  return (
    <>
      <Navbar />
      <Box sx={{ height: "50px" }} />
      <HeroSection />
      <ValeurSection />
      <AccompagnementSection/>
      <EquipeSection />
      <Footer />
    </>
  );
};

export default Nous;
